import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DescriptionPage.css'; // Можно использовать общие стили
import { EMOTIONS } from '../constants/emotions';

function EmotionListPage() {
  const navigate = useNavigate();
  
  const handleReturnToTest = () => {
    const trainingCompleted = localStorage.getItem('emotionSurveyTrainingCompleted') === 'true';
	const currentIndex = localStorage.getItem('trainingCurrentIndex');
    const currentTestMode = localStorage.getItem('emotionSurveyCurrentTestMode');
	
	if (currentIndex === null && !currentTestMode) {
      navigate('/experiment-intro');
      return;
    }

    if (!trainingCompleted) {
      navigate(`/training-task?index=${currentIndex ?? 0}`);
      return;
    }

    if (currentTestMode === 'sound') {
      navigate('/task-sound');
    } else if (currentTestMode === 'silent') {
      navigate('/task-silent');
    }
  };

  return (
    <div className="page-container description-page">
      <h1>Для целей данного исследования термины эмоций можно определить следующим образом:</h1>
      <ul className="emotion-definitions-list">
        {EMOTIONS.map(emotion => (
          <li key={emotion.name}>
            <strong>{emotion.name}</strong> - {emotion.description}
          </li>
        ))}
      </ul>
	  
      <div className="navigation-buttons">
        <button onClick={handleReturnToTest}>Вернуться к тесту</button>
      </div>
    </div>

  );
}

export default EmotionListPage;